<template>
    <div>
        <rich-client-header v-show="!isSecondary || (isSecondary && !isMobile)"/>
        <main class="container" style="padding-bottom: 3rem;">
            <rich-header-secondary-level v-if="isSecondary" back-url="/"
                                         back-label="Retour aux danseurs"
            />
            <slot/>
        </main>
        <rich-client-nav-mobile v-show="!isSecondary || (isSecondary && !isMobile)"/>
    </div>
</template>

<script>
    import RichClientNavMobile from "../components/c-blocks/RichClientNavMobile";
    import RichClientHeader from "../components/c-blocks/RichClientHeader";
    import {mapGetters} from 'vuex'
    import RichHeaderSecondaryLevel from "../components/c-blocks/RichHeaderSecondaryLevel";

    export default {
        components: {RichHeaderSecondaryLevel, RichClientHeader, RichClientNavMobile},
        data() {
            return {
                showMenu: true,
                secondaryHeader: {
                    backUrl: '',
                    backLabel: '',
                    title: '',
                },
                isSecondary: false,
                isMobile: false
            }
        },
        computed: {
            ...mapGetters({
                currentFamily: 'currentFamily'
            })
        },
        methods: {
            isUserOnMobile() {
                const width = window.innerWidth || document.documentElement.clientWidth ||
                    document.body.clientWidth
                this.isMobile = width < 768
            },
            checkUserLogin() {
                if (!localStorage.token) {
                    console.log('pas de token')
                } else {
                    console.log('token')
                }
                if (!this.currentFamily) {
                    this.$router.push('/connexion')
                } else {
                    this.checkUserAdmin()
                }
            },
            checkUserAdmin() {
                if (this.currentFamily.is_admin) {
                    this.$router.push('/admin')
                }
            }
        },
        updated() {
            this.isSecondary = this.$route.meta.isSecondary || false
        },
        created() {
            this.checkUserLogin()
            window.addEventListener('resize', () => {
                this.isUserOnMobile()
            })
            this.isSecondary = this.$route.meta.isSecondary || false
        }
    }
</script>

<style scoped lang="scss">
    /deep/ main {
        padding-top: 54px;
    }

    /deep/ .main-title {
        margin-bottom: 24px;
    }

    @include screen-m {
        /deep/ main {
            padding-top: 108px;
        }
    }
</style>
